export { useGetSentCommunicationApi } from './useGetSentCommunicationApi';
export { reducerGetSentCommunicationApi } from './reducerGetSentCommunicationApi';
